// holds the subscriber functions
var subscribers = {};
var idCount = 0;
export var unsubscribe = function (id) {
    if (subscribers[id])
        delete subscribers[id];
};
export var subscribeToEvents = function (subscriberFunction) {
    var id = idCount;
    idCount++;
    subscribers[id] = subscriberFunction;
    return { unsubscribe: function () { return unsubscribe(id); } };
};
export var triggerSubscribers = function (event) {
    Object.keys(subscribers).forEach(function (id) { return subscribers[id](event); });
};
